import { AppointmentsCalendar, AppointmentsList, ListHeader } from '@/features/appointments';
import { useAppointmentsPage } from '@/features/appointments/hooks/useAppointmentsPage';
import { useBreadcrumbs } from '@/hooks/useBreadcrumbs';

export default function AppointmentsPage() {
    const {
        viewMode,
        filterValues,
        currentPage,
        selectedCalendarDate,
        calendarEvents,
        calendarLoading,
        calendarIsError,
        calendarError,
        listAppointments,
        listLoading,
        listIsError,
        listError,
        pagination,
        isDeleting,
        handleAppointmentClick,
        handleViewModeChange,
        handleFilterChange,
        handleResetFilters,
        handlePageChange,
        handleCalendarNavigate,
        handleBlockTime,
        handleDeleteBlockedTime,
        handleGetAppointmentsForDay,
    } = useAppointmentsPage();

    const handleDateSelect = (_date: Date) => {
        // TODO: Handle date selection logic
    };

    useBreadcrumbs([{ title: 'My Appointments', to: '/appointments', active: true, id: 'appointments' }]);

    const pageContent = (
        <div className='flex w-full min-w-0 flex-col gap-6'>
            {viewMode === 'calendar' && calendarIsError && (
                <div className='bg-negative-subtle text-negative-dark mb-4 rounded-lg p-4'>
                    <p className='font-medium'>Error loading appointments</p>
                    <p className='text-sm'>
                        {calendarError?.message || 'An error occurred while fetching appointments'}
                    </p>
                </div>
            )}

            {viewMode === 'list' && listIsError && (
                <div className='bg-negative-subtle text-negative-dark mb-4 rounded-lg p-4'>
                    <p className='font-medium'>Error loading appointments</p>
                    <p className='text-sm'>{listError?.message || 'An error occurred while fetching appointments'}</p>
                </div>
            )}

            <div className='shadow-nucleus-elevation-medium bg-canvas rounded-lg p-4 lg:p-6'>
                {viewMode === 'calendar' ? (
                    <AppointmentsCalendar
                        events={calendarEvents}
                        selectedDate={selectedCalendarDate}
                        isLoading={calendarLoading}
                        onDateNavigate={handleCalendarNavigate}
                        onDateSelect={handleDateSelect}
                        onAppointmentClick={handleAppointmentClick}
                        onBlockTime={handleBlockTime}
                        onDeleteBlockedTime={handleDeleteBlockedTime}
                        isDeleting={isDeleting}
                        getAppointmentsForDay={handleGetAppointmentsForDay}
                        viewMode={viewMode}
                        onViewModeChange={handleViewModeChange}
                    />
                ) : (
                    <>
                        <ListHeader
                            filterValues={filterValues}
                            onFilterChanged={handleFilterChange}
                            onResetFilters={handleResetFilters}
                            viewMode={viewMode}
                            onViewModeChange={handleViewModeChange}
                        />
                        <AppointmentsList
                            appointments={listAppointments}
                            isLoading={listLoading}
                            onAppointmentClick={handleAppointmentClick}
                            page={pagination?.page || currentPage}
                            totalPages={pagination?.totalPages || 1}
                            onPageChange={handlePageChange}
                        />
                    </>
                )}
            </div>
        </div>
    );

    return pageContent;
}
